import React from 'react';
import { createToast, Toast, ToastButton } from 'components/core';
import { getToastConfig } from '../../constants/httpErrorToasts';

export const showErrorToast = (statusCode) => {
  const toastConfig = getToastConfig(statusCode);

  createToast(
    React.createElement(Toast, {
      type: "danger",
      role: "alert",
    },
      toastConfig.message,
      React.createElement(ToastButton, {
        to: toastConfig.buttonLink,
      }, toastConfig.buttonLabel)
    )
  );
};
